export default __webpack_public_path__ + "static/media/skis_dark.ce03e1e3.png";